
























































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import Address from '@/views/app/management/components/Address.vue'
import Vue2Filters from 'vue2-filters'
import { PaymentsModule } from '@/store/modules/payments.module'
import Card from '@/components/Card.vue'
import { EPaymentMethodType, isObj } from '@zunta/configurations'

@Component({
  mixins: [Vue2Filters.mixin],
  name: 'HMOPaymentApproved',
  components: {
    Card,
    Address,
    AddressesPopup
  }
})
export default class HMOPaymentApproved extends Vue {
  paymentModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  isObj = isObj
  EPaymentMethodType = EPaymentMethodType

  get payment () {
    return this.$store.state.payments.currentPayment
  }

  get paymentId () {
    return this.$route.params.id
  }

  async mounted () {
    await this.paymentModuleInstance.getPaymentStatusById(this.paymentId)
  }

  goBack () {
    this.$router.push({ name: 'management-payments-sections-processed' })
  }
}

